"use client";
import React, { useState } from "react";

const FileUpload = ({ value }) => {
  const [file, setFile] = useState(null);
  const [fileURL, setFileURL] = useState(null);

  const handleFileChange = (event) => {
    const selectedFile = event.target.files?.[0];

    if (selectedFile && selectedFile.type === "application/pdf") {
      value(selectedFile);

      setFile(selectedFile);
      setFileURL(URL.createObjectURL(selectedFile)); // Create a preview URL
    } else {
      alert("Please upload a valid PDF file.");
      setFile(null);
      setFileURL(null);
    }
  };

  return (
    <div className="flex flex-col items-center p-4 border rounded-lg shadow-md bg-white dark:bg-gray-800 w-96">
      <label className="cursor-pointer bg-blue-500 text-white px-4 py-2 rounded-md hover:bg-blue-600">
        Upload PDF
        <input
          type="file"
          accept="application/pdf"
          onChange={handleFileChange}
          className="hidden"
        />
      </label>

      {file && (
        <div className="mt-4 text-center">
          <p className="text-sm font-semibold">{file.name}</p>
          {/* <div className="mt-2 w-full  rounded-lg overflow-hidden">
            <img src="" alt="" style={{ height: "60px", width: "60px" }} />
          </div> */}
        </div>
      )}
    </div>
  );
};

export default FileUpload;
